import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async highlight => { // 'comp-highlight'
    // Inview Setup
    const { default: ScrollMagic } = await import('scrollmagic'),
        controller = new ScrollMagic.Controller();

    (new ScrollMagic.Scene({ triggerElement: highlight.nextElementSibling || highlight, triggerHook: 0.9 })
        .on("enter", () => highlight.classList.add('inview'))
        .addTo(controller));


    // Resource Setup
    [...highlight.querySelectorAll('a.btn:not(.resource-item)')].forEach(button => {
        const href = button.getAttribute('href'),
            target = button.getAttribute('target');
        [...highlight.querySelectorAll(':scope > comp-background:not([hasbutton]), h5, h4, h3')].forEach(clickItem => {
            clickItem.addEventListener('click', () => {
                if (target === '_blank') {
                    window.open(href);
                }
                else {
                    window.location.href = href;
                }
            });
            clickItem.style.cursor = 'pointer';
        });
    });


    // Slideshow setup
    const swiperContainer = domWrap(highlight.querySelector('.swiper-container'));
    if (swiperContainer.empty) return;

    swiperContainer
        .wrapInner(h('div class="swiper-wrapper"').Node)
        .insertAdjacentHTML('beforeend', h('div class="swiper-pagination"')('div class="swiper-button-prev"')('div class="swiper-button-next"').toString());

    const slides = [...swiperContainer.querySelectorAll('comp-background')],
        link = swiperContainer.parentNode.querySelector(':scope > inner-content:not(.swiper-container) a.btn');

    slides.forEach(slide => slide.classList.add('swiper-slide'));

    if (slides.length > 0) {
        const { default: Swiper } = await import('swiper');
        new Swiper(swiperContainer, {
            // Optional parameters
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 0,
            effect: 'slide',
            speed: 600,
            pagination: swiperContainer.querySelector('.swiper-pagination'),
            paginationClickable: true,
            nextButton: swiperContainer.querySelector('.swiper-button-next'),
            prevButton: swiperContainer.querySelector('.swiper-button-prev'),
            // breakpoints: {
            //     767: {
            //     slidesPerView: 1,
            //     spaceBetween: 20
            //     }
            // }
        });
    }

    if (link) {
        swiperContainer.on('click', '.swiper-wrapper > *', () => {
            let href = link.getAttribute('href');
            switch (link.getAttribute('target')) {
                case '_blank':
                    window.open(href);
                    break;
                default:
                    window.location.href = href;
            }
        }).classList.add('clickable');
    }
};